export default "__VITE_ASSET__DB7pZbH1__"